import React from "react";
import { Route } from "react-router-dom";

import Layout from "../../../components/Layout";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";

import config from "../../../config";

const RedirectToLoginPage = () => (
    <Route
        component={() => {
            window.location.href = `${config.LOGIN_PAGE}?redirectTo=${window.location.pathname}`;
            return null;
        }}
    />
);

const PageContainer = ({
    isLoading,
    isLoggedIn,
    error,
    canApply,
    children,
}) => {
    if (isLoading)
        return (
            <Layout>
                <Loading />
            </Layout>
        );

    if (error)
        return (
            <Layout>
                <Error error={error} />
            </Layout>
        );

    if (canApply !== null && canApply === false) return <RedirectToLoginPage />;

    if (isLoggedIn === false) return <RedirectToLoginPage />;

    return children;
};

export default PageContainer;
